import {AxiosServer, ArrRemoveSubItem,AxiosEsb} from '../../utils';
import {message} from 'antd';
let namespace = 'derWareHouseOut_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const derWareHouseOutAc ={
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},
	
	GET:(value)=>(dispatch,getState)=>{
		let store =getState().derWareHouseOutRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}
		
		let Axios = AxiosServer();
		return Axios.post('/derWareHouseOut/findAll',dataFetchProps).then((res)=>{
						
			if (res.data.status == true){
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('userlist ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})},

	// 出库试算
	WAREHOUSEVALUECALPICKUPWH:(value = null)=>(dispatch,getState)=>{
		//可以多次dispatch(),  getState() 可获取当前store的状态
		//dispatch({type:'login/set',payload:{loading:true}});
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/warehouseValueCalPickupWh',value).then((res)=>{
			console.log(res.data.status)
			if (res.data.status){
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '试算完成'
			}else {

				return res.data.msg;
			}
		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})
	},


	// 出库申请
	WAREHOUSESUBMITOUTAPPLYWH:(value)=> (dispatch,getState)=>{

		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/warehouseSubmitOutApplyWh',value).then((res)=>{

			//提交成功，更新数据

			if (res.data.status){

				//更新后台为同意

				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '出库申请推送成功';
			}

			return res.data.msg;


		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})

	},


}



export {derWareHouseOutAc};